/** @jsxImportSource react */
import React from 'react';

export default function Main({ children }: { children: React.ReactNode }) {
  return (
    <main className='my-0 mx-auto w-full px-m py-0 md:w-[var(--col8)] md:p-0 lg:w-[var(--col12)]'>
      {children}
    </main>
  );
}
